<template>
    <div class="accordion-item eb-chapter-toggle">
      <b-button
        @click="handleClick"
        variant="none"
        :class="['accordion-button', {'collapsed': !visible }]"
      >
        <span class="head-text">{{ headerTitle }}</span>
  
        <span class="side-text" v-if="sideText && !showCompleted">{{ sideText }}</span>
  
        <div class="completed-alert d-flex align-items-center ms-4" v-if="showCompleted">
          <div class="btn btn-primary btn-sm mark-complete-btn chapter completed me-3">
            <img src="../../assets/images/check-green-circle-icon.svg" width="12" height="12" />
            Completed
          </div>
        </div>
      </b-button>
  
      <b-collapse
        :id="'accordion-' + uniqueId"
        :visible="visible"
        class="accordion-collapse eb-toggle-body"
        role="tabpanel"
      >
        <div class="accordion-body">
          <slot />
        </div>
      </b-collapse>
    </div>
  </template>
  
  <script>
  export default {
    name: "ProductContentChaptersAccordion",
    props: {
      headerTitle: {
        type: String,
        required: true,
      },
      sideText: {
        type: String,
        default: null,
      },
      showCompleted: {
        type: Boolean,
        default: false,
      },
      uniqueId: {
        type: [String, Number],
        required: true,
      },
      visible: {
        type: Boolean,
        default: false,
      },
      toggle: {
        type: Function,
      }
    },
    methods: {
      handleClick() {
        this.toggle?.()
      },
    },
  };
  </script>  
  
  <style scoped>
  .eb-chapter-toggle .accordion-button {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
  
  .eb-chapter-toggle .accordion-button .head-text {
    color: #231F20;
    font-family: 'Circular Std', sans-serif;
    font-size: 15px;
    font-style: normal;
    font-weight: 500;
    line-height: 1.2;
    flex-grow: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    white-space: normal;
    margin-right: 10px;
    text-transform: capitalize;
  }
  
  .eb-chapter-toggle .accordion-button .side-text {
    white-space: nowrap;
    flex-shrink: 0;
  }
  
  .eb-chapter-toggle .accordion-button .completed-alert {
    white-space: nowrap;
    flex-shrink: 0;
  }
  
  .completed-alert {
    color: var(--primary-color);
    font-weight: bold;
  }
  
  .mark-complete-btn {
    position: relative;
    padding: 6px 15px 4px 34px;
    text-align: left;
  }
  
  .mark-complete-btn span,
  .mark-complete-btn img {
    width: 16px;
    height: 16px;
    display: inline-block;
    border-radius: 50%;
    border: solid 1px var(--border-color);
    position: absolute;
    left: 10px;
    top: 8px;
  }
  
  .mark-complete-btn img {
    border: none;
    border-radius: 0;
    width: 18px;
    height: 18px;
    left: 9px;
    top: 7px;
  }
  
  .mark-complete-btn.completed,
  .mark-complete-btn.completed:hover {
    border-color: var(--confidence-label-high);
    color: var(--confidence-label-high);
    background-color: white;
  }
  
  .eb-chapter-toggle .accordion-button:not(.collapsed)::after,
  .eb-chapter-toggle .accordion-button::after {
    background: rgba(255, 255, 255, 1);
    border: 1.5px solid black;
    color: black;
  }
  
  .accordion-item.eb-chapter-toggle {
    filter: drop-shadow(0px 3px 6px rgba(213, 213, 213, 0.16));
  }
  
  .accordion-button:not(.collapsed) {
    color: black;
    height: auto;
    min-height: 42px;
  }
  
  button.btn.accordion-button.btn-none.btn-block.collapsed,
  button.btn.accordion-button.btn-none.btn-block.not-collapsed {
    height: auto;
    min-height: 42px;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  </style>
  